import { h } from 'preact';
import Store from 'store/store';
import 'store/bolt/previewPanel';
// import 'store/bolt/homeEntLoader';
// import { geoFromIP } from 'utils/bolt/geo';
import { joinClasses, accessNested, parseDate } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import { smoothScrollTo } from 'utils/smoothScroll';
import formatDateTime from 'utils/formatDateTime';
import * as webp from 'utils/bolt/webp';
import { useDynamicAssetFolder } from 'utils/assets';
import { getPreviewPanelHomeEntData } from 'utils/bolt/previewPanel';
import { checkMerchantRegionalLogo } from 'utils/bolt/homeEnt';
import { getValueForClientSize, getTTSizeOverride, isVideosPage, linkOut, getHeaderHeight } from 'utils/bolt';
import { getMerchantLogo } from 'services/fafApi';

import HTML from 'components/core/html/html';
import Section from 'components/bolt/section/section';
import Button from 'components/bolt/button/button';
// import ShowtimesMessage from 'components/bolt/showtimes/showtimesMessage';
// import ProviderInterstitial from 'components/bolt/showtimes/providerInterstitial';
// import Theater from 'components/bolt/showtimes/theater';
import ArrowDown from 'components/bolt/icons/arrowDown';
import Socials from 'components/bolt/socials/socials';
// import MerchantPanel from 'components/bolt/homeEnt/merchantPanel';

let ShowtimesMessage;
let ProviderInterstitial;
let Theater;
let MerchantPanel;

import s from 'components/bolt/previewPanel/previewPanel.sss';

const theaterModeToSource = {
	list: 'listings_view',
	expanded: 'cinema_view',
	collapsed: 'map_view'
};

const replaceLegacyViewIds = (view, pages) => {
	if (view === 'showtimes' && !pages.showtimes && pages.boltShowtimes) {
		return 'boltShowtimes';
	}
	if (view === 'homeEnt' && !pages.homeEnt && pages.boltHomeEnt) {
		return 'boltHomeEnt';
	}
	return view;
};

async function loadShowtimesComponents() {
	try {
		[
			{ default: ShowtimesMessage },
			{ default: ProviderInterstitial },
			{ default: Theater },
		] = await Promise.all([
			import('components/bolt/showtimes/showtimesMessage'),
			import('components/bolt/showtimes/providerInterstitial'),
			import('components/bolt/showtimes/theater'),
		]);
	} catch (e) {}
}
async function loadHomeEntComponents() {
	try {
		[
			{ default: MerchantPanel },
		] = await Promise.all([
			import('components/bolt/homeEnt/merchantPanel'),
		]);
	} catch (e) {}
}

export default class PreviewPanel extends Section {
	constructor(props) {
		super(props);

		const pages = this.props.appData?.pages;
		let pageData = pages[this.props.id]?.data || {};
		const enabledViews = pageData.enabledViews || '';
		// const views = enabledViews.split(',').map(e => e.trim());
		this.views = enabledViews.split(',').map(e => e.trim()).map(view => {
			let [name, optionsString] = view.split(':');
			name = replaceLegacyViewIds(name, pages);

			let result = {
				source: view,
				name,
				options: this.parseOptionsString(optionsString, name)
			};

			result.copy = this.getViewCopy(result);
			return result;
		}).filter(e => e);
		this.displayMerchantViewsStacked = pageData.displayMerchantViewsStacked;

		this.homeEntEnabled = this.views.find(view => this.isHomeEntView(view, props));
		this.showtimesEnabled = this.views.find(view => this.isShowtimesView(view, props));

		if (this.homeEntEnabled) {
			loadHomeEntComponents().then(() => this.forceUpdate());
		}
		if (this.showtimesEnabled) {
			loadShowtimesComponents().then(() => this.forceUpdate());
		}

		let defaultView = this.views.find(view => view.source === pageData.defaultView) || this.views[0];

		let queryStringView = parseQueryString()?.view;
		// Priority to fully qualified name:options version
		let viewFromQueryString = queryStringView && (this.views.find(e => e.source === queryStringView) || this.views.find(e => e.name === queryStringView));
		defaultView = viewFromQueryString || defaultView;

		// this.dualView = views.length === 2;
		this.logoShade = this.props?.store.appData.styling.logoShade || 'light';
		this.availabilityOrder = ['stream', 'rent', 'buy', 'preOrder', 'comingSoon'].reverse();
		this.$theaters = {};
		this.$sections = {};

		this.state = {
			activeView: defaultView,
			validCountry: true,
			selectedMerchant: '',
			selectedMerchantData: {},
			selectedLogo: '',
			merchantScreenOpen: false,
			regionToTrack: null,
			scrolledALittleBit: false,
			posterVisible: true
		};

		this.changeActiveView = this.changeActiveView.bind(this);
		this.renderView = this.renderView.bind(this);
		this.renderHomeEntData = this.renderHomeEntData.bind(this);
		this.closeMerchantSection = this.closeMerchantSection.bind(this);
		this.maybeCloseMerchantSection = this.maybeCloseMerchantSection.bind(this);
		this.onPriceBtnClick = this.onPriceBtnClick.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.scrollToNext = this.scrollToNext.bind(this);
		this.triggerExtraButton = this.triggerExtraButton.bind(this);
	}
	
	async componentDidMount() {
		super.componentDidMount();

		if (this.showtimesEnabled) {
			// Get geo without blocking the rest of the function
			this.geolocation = this.setGeo();
			import('utils/bolt/showtimes').then(({ getBoundingRegions }) => {
				const boundingRegions = getBoundingRegions('boltShowtimes');
				this.setState({ boundingRegions });
				this.checkCountry(boundingRegions);
			});
		}

		document.getElementById('mainScroll').addEventListener('scroll', this.handleScroll);

		if (this.displayMerchantViewsStacked) {
			this.views.forEach(view => this.getDataForActiveView(view));
		} else {
			this.getDataForActiveView(this.state.activeView);
		}
	}

	componentWillUpdate() {
		clearTimeout(this.heightResetTimeout);
		this.transitionSectionHeightFrom = this.sectionContainer?.clientHeight;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.activeView !== prevState.activeView) {
			this.getDataForActiveView(this.state.activeView);
		}

		this.checkCountry();

		let isDesktopSize = this.props.store?.client?.isDesktopSize;

		// Make all the theaters match header (name+address) height on desktop
		let $theaters = Object.values(this.$theaters).filter(e => e);
		let maxHeaderHeight = isDesktopSize ? Math.max(...$theaters.map(th => th.header.offsetHeight)) : NaN;
		if (isFinite(maxHeaderHeight)) {
			$theaters.forEach(th => th.header.style.height = maxHeaderHeight + 'px');
		} else {
			$theaters.forEach(th => th.header.style.height = '');
		}

		this.transitionHeight();

		// Do we need this ?
		// clearTimeout(this.bgTimeout);
		// if (this.sectionBackground) {
		// 	this.bgTimeout = window.setTimeout(() => {
		// 		const currentHeight = this.wrapper.offsetHeight;
		// 		const activeSectionHeight = this.$sections[this.state.activeSection]?.offsetHeight || 0;
		// 		const tallestSectionHeight = Math.max(...Object.values(this.$sections).map(section => section?.offsetHeight || 0));
		// 		this.sectionBackground.forceBgSize({ height: currentHeight - activeSectionHeight + tallestSectionHeight });
		// 	}, 500);
		// }
	}

	componentWillUnmount() {
		// this.resizeObserver.disonnect();
		// clearTimeout(this.bgTimeout);
		clearTimeout(this.heightResetTimeout);

		document.getElementById('mainScroll').removeEventListener('scroll', this.handleScroll);
	}

	checkCountry(boundingRegions = this.state.boundingRegions) {
		const countryCode = this.props.store?.client?.geo?.countryCode;
		let validCountry = !boundingRegions || boundingRegions.includes(countryCode?.toUpperCase());
		if (validCountry !== this.state.validCountry) {
			this.setState({ validCountry });
		}
	}

	isShowtimesView(view, props = this.props) {
		return props.appData?.pages?.[view.name]?.type === 'showtimes';
	}
	isHomeEntView(view, props = this.props) {
		return props.appData?.pages?.[view.name]?.type === 'homeEnt';
	}

	parseOptionsString(str, viewName) {
		let options = {};

		let pages = this.props.appData?.pages;
		let pageForView = pages[viewName] || {};

		if (pageForView?.type === 'homeEnt') {
			// TODO: advanced parsing
			options.region = str;
		}

		return options;
	}

	getViewCopy(view) {
		let page = this.props.appData?.pages?.[view.name];

		if (page?.type === 'homeEnt' && view.options?.region) {
			let region = view.options?.region;
			let regionData = page?.data?.customiseRegion;
			return regionData?.[region]?.shortTitle || regionData?.[region]?.title || region;
		}

		return this.props.appData?.copy?.baseCopy?.[page?.name] || page?.name || view.name;
	}

	handleScroll(e) {
		const { scrolledALittleBit } = this.state;
		const newScrolledALittleBit = e.target.scrollTop > 80;
		if (newScrolledALittleBit !== scrolledALittleBit) {
			this.setState({ scrolledALittleBit: newScrolledALittleBit });
		}
	}

	async setGeo() {
		const { geoFromIP } = await import('utils/bolt/geo');
		const data = await geoFromIP();
		Store.emit('GEO_FROM_IP', data);
		this.setState({ geoFromIP: data });
	}

	transitionHeight() {
		let $el = this.sectionContainer;
		if (!$el || !this.transitionSectionHeightFrom) {
			return;
		}
		$el.style.height = 'auto';
		let destinationHeight = $el.offsetHeight;
		$el.style.height = this.transitionSectionHeightFrom + 'px';
		// Reflow
		$el.offsetHeight;
		$el.style.height = destinationHeight + 'px';
		this.heightResetTimeout = setTimeout(() => $el.style.height = '', 500);
	}

	async getDataForActiveView(view) {
		if (this.isHomeEntView(view)) {
			await import('store/bolt/homeEnt');
			try {
				await this.props.store.homeEnt['loading-' + view.name];
			} catch (e) {}
			if (!this.props.store.homeEnt['data-' + view.name]) {
				// Should be a util function rather than a store evemt
				await Store.emit('GET_HOMEENT_DATA', view.name, view.options);
			}
			getPreviewPanelHomeEntData(view.name, { storeName: view.source, ...view.options });
			return;
		}
		if (this.isShowtimesView(view)) {
			await import('store/bolt/showtimes');
			// We should probably pass the page id somehow
			if (!this.props.store?.showtimes?.data && !this.props.store?.client?.geo?.loading) {
				await this.geolocation;
				Store.emit('FILTERS_REFRESH', { forceShowtimesRefresh: true });
			}
			return;
		}
	}

	changeActiveView(view) {
		this.setState({ activeView: view });
	}

	expandTheater(theater) {
		Store.emit('PREVIEW_PANEL_THEATER_CLICK', theater.name, theater.chain?.name || '-');
		return Store.emit('SHOWTIMES_SHOW');
	}

	getLogoSrc(merchant, logo, region) {
		if (!merchant) return;
		// merchantLogoOverrides will be legacy soon, let's give it lower priority than the logo override from overrideMerchantDetails
		const merchantLogoOverrides = accessNested(this.props, 'store.appData.pages.boltHomeEnt.data.overrideMerchantLogos', {});
		const merchantDetailsOverrides = accessNested(this.props, 'store.appData.pages.boltHomeEnt.data.overrideMerchantDetails', {});
		const manualLogo = merchantDetailsOverrides[merchant]?.logo || merchantLogoOverrides[merchant];

		if (manualLogo) return manualLogo;

		const logoShade = accessNested(this.props, 'store.appData.styling.logoShade', 'light');
		// logos from service-homeent use the prod logos, so let's always use them to prevent
		// inconsistencies on demo
		const sharedImageRoot = 'https://dx35vtwkllhj9.cloudfront.net/images';

		// manually added, probably
		if (!logo) {
			if (checkMerchantRegionalLogo(merchant, region)) {
				return `${sharedImageRoot}/boltHomeEntMerchants/${logoShade}/${region}/${merchant}_${logoShade}.png`;
			}
			return `${sharedImageRoot}/boltHomeEntMerchants/${logoShade}/${merchant}_${logoShade}.png`;
		}

		// generated and returned from service-homeent
		if (logo.match(/boltHomeEntMerchants/)) {
			return logo.replace(/<shade>/g, logoShade);
		}

		if (logo.match(/merchantlogo.s3-eu-west-1.amazonaws.com\/hub/)) {
			return this.convertFafMerchantLogo(merchant);
		}

		return logo;
	}

	convertFafMerchantLogo(merchant) {
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages');
		return getMerchantLogo(merchant, sharedImageRoot);
	}

	getFallbackFormat(type) {
		const defaultFormat = type === 'tt' ? 'png' : 'jpg';
		const region = type === 'tt' ? 'tt' : 'bg';
		return accessNested(this.props, `store.appData.pages.boltHomeEnt.data.${region}.alternativeImageFormat`, defaultFormat);
	}

	getSingleLinkForMerchant(merchantData, userSelectedAvailabilities) {
		let link;
		let productId;
		let edition;
		let price;
		let availForProduct;
		let productCount = 0;

		userSelectedAvailabilities.forEach(a => {
			if (merchantData[a] && merchantData[a].length) {
				productCount += merchantData[a].length;
				link = merchantData[a][0].link;
				productId = merchantData[a][0].id;
				edition = merchantData[a][0].edition;
				price = merchantData[a][0].price;
				availForProduct = a;
			}
		});

		if (productCount !== 1) return false;
		return { link, productId, edition, price, availForProduct };
	}

	openMerchant(data, logo, singleLinkOutData, regionData, merchant, currentRegion, i) {
		const hasNoLinks = (singleLinkOutData && !singleLinkOutData.link) || (Object.keys(data).filter(a => a !== 'textOverlay' && a !== 'order').length <= 0);

		if (hasNoLinks) return;

		const appRegion = accessNested(this.props, 'store.appData.meta.region.slug');
		let regionToTrack = currentRegion;
		if (regionToTrack === 'default') regionToTrack = appRegion;

		Store.emit('HOME_ENT_MERCHANT_SELECT', {
			region: regionToTrack,
			merchant
		}, 'previewpanel');

		if (singleLinkOutData && (!data.comingSoon || (data.comingSoon && data.comingSoon.expired))) {
			this.onPriceBtnClick({
				id: singleLinkOutData.productId,
				price: singleLinkOutData.price,
				edition: singleLinkOutData.edition
			}, singleLinkOutData.availForProduct, merchant, regionToTrack);
			linkOut(singleLinkOutData.link);
			return;
		}

		if (data.comingSoon && data.comingSoon.expired && (Object.keys(data).length === 1 || (Object.keys(data).length === 2 && !!data.order))) {
			return;
		}

		this.setState({
			merchantScreenOpen: true,
			selectedMerchantData: data,
			selectedMerchant: merchant,
			regionToTrack,
			selectedLogo: logo,
			selectedRegionData: regionData
		});
	}

	// We should make a generic util function for this and use it in showtimes, showtimesv2 and here
	trackConversion(theater, screening, provider, mode, url) {
		if (!theater || !screening) {
			return;
		}

		let format = screening.format.trim() === '' ? 'absent' : screening.format;

		let conversion = [
			theater.name,
			accessNested(theater, 'chain.name'),
			screening.date,
			screening.time,
			format,
			provider
		].join('_');

		if (conversion.split('').length > 100) {
			conversion = [
				theater.name.substring(0, 50),
				accessNested(theater, 'chain.name'),
				screening.date,
				screening.time,
				format,
				provider
			].join('_');
		}

		let screeningMovie = screening.movie?.regions?.find(m => m.country === 'INTL');

		Store.emit('TICKET_CONVERSION', {
			screening,
			theater,
			date: screening.date,
			time: screening.time,
			format: format,
			provider,
			conversion,
			source: theaterModeToSource[mode] || 'listings_view',
			theaterName: theater.name,
			day: formatDateTime(parseDate(screening.date), 'dddd'),
			url,
			movieTitle: screeningMovie?.title,
			movieSlug: screeningMovie?.slug,
		}, 'previewpanel');
	}

	triggerExtraButton(path, label, sameWindow) {
		Store.emit('PREVIEW_PANEL_EXTRA_BUTTON_CLICK', label);
		// Should use navigateInternally from utils/bolt if that does not cause other issues
		if (path.includes('http')) {
			let link = document.createElement('a');
			link.href = path;
			link.target = sameWindow ? '_self' : '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else if (path.startsWith('@')) {
			return Store.emit('OPEN_RESERVED_VARIABLE_LINK', path);
		} else if (isVideosPage(path)) {
			return Store.emit('OPEN_VIDEO_OVERLAY', path);
		} else if (path === 'boltShowtimes') {
			return Store.emit('SHOWTIMES_SHOW', true);
		} else if (path === 'boltHomeEnt') {
			return Store.emit('HOMEENT_SHOW', true);
		} else if (path === 'scrollTop') {
			smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		} else {
			const logo = label.toLowerCase() === 'logo';
			let pageData = this.props.appData?.pages?.[this.props.activePage];
			const isRootPath = pageData?.path === '/';
			if (isRootPath && logo) {
				return smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
			}
			return Store.emit('CLOSE_AND_NAVIGATE', path, '', { instant: false });
		}
	}

	renderTT(tt) {
		const copy = this.props.appData?.copy;
		const size = getTTSizeOverride(tt);
		const ttStyle = {
			...size
		};

		return (
			<webp.Picture
				class={s.tt}
				style={ttStyle}
				alt={copy.accessibilityCopy[tt.alt] || tt.alt}
				src={useDynamicAssetFolder(getValueForClientSize(tt, this.props.client))}
				fallbackFormat="png"
				key="previewpaneltt"
			/>
		);
	}

	renderExtraButton(button, isBottom) {
		const {
			path,
			label,
			sameWindow
		} = button;
		const copy = this.props.appData?.copy.baseCopy;

		return (
			<Button
				class={joinClasses(s.extraButton, isBottom && s.isBottom)}
				trigger={() => this.triggerExtraButton(path, label, sameWindow)}
				type="floating"
				key="preview-extra"
			>
				<HTML
					class={s.persistentBtnLabel}
					content={copy[label] || label}
					markdown
				/>
			</Button>
		);
	}

	renderToggle() {
		if (this.views.length <= 1) {
			return;
		}

		const { activeView } = this.state;

		return (
			<div class={joinClasses(s.toggleWrapper, 'mediumB')} key="togglewrapper">
				{this.views.map(view => {
					return (
						<button
							class={joinClasses(s.toggle, view === activeView ? s.on : s.off)}
							onClick={() => this.changeActiveView(view)}
							key={view.source}
						>
							{view.copy}
						</button>
					);
				})}
			</div>
		);
	}

	renderHomeEntData(view) {
		const pageId = view.name;
		const appData = this.props.appData;
		const maxMerchants = appData?.pages[this.props.id].data?.maxMerchants || 5;
		const copy = appData?.copy?.baseCopy;
		const loading = this.props.store?.homeEnt?.loading !== false;
		const isMobile = !this.props.client?.isDesktopSize;
		const pageData = appData.pages[this.props.id].data || {};
		const extraButtonBottom = pageData.extraButton?.position === 'bottom';
		const { activeOn } = pageData.extraButton || {};
		const extraBtnActive = activeOn?.split(',').some(e => {
			return [view.source, view.name, appData.pages[view.name]?.type].includes(e.trim());
		});
		const showExtraButton = pageData.extraButton && extraButtonBottom && (!activeOn || extraBtnActive);

		return (
			<div
				ref={ref => this.$sections[pageId] = ref}
				class={joinClasses(s.view, s.homeEnt, this.state.activeView === view && s.show)}
			>
				{this.displayMerchantViewsStacked ? this.renderViewsStacked() : this.renderMerchantsForView(view, maxMerchants, loading, isMobile)}
				<Button
					class={s.button}
					type="floating"
					trigger={() => {
						Store.emit('PREVIEW_PANEL_MORE_MERCHANTS_CLICK');
						Store.emit('HOMEENT_SHOW', undefined, undefined, pageId);
					}}
				>
					{copy.$MORE_WAYS_TO_WATCH || 'More Ways To Watch'}
				</Button>
				{showExtraButton && this.renderExtraButton(pageData.extraButton, extraButtonBottom)}
			</div>
		);
	}

	renderViewsStacked() {
		const appData = this.props.appData;
		const maxMerchants = appData?.pages[this.props.id].data?.maxMerchants || 5;
		const loading = this.props.store?.homeEnt?.loading !== false;
		const isMobile = !this.props.client?.isDesktopSize;

		return this.views.map(view => this.renderMerchantsForView(view, maxMerchants, loading, isMobile));
	}

	renderMerchantsForView(view, maxMerchants, loading, isMobile) {
		const pageId = view.name;
		const appData = this.props.appData;
		const copy = appData?.copy?.baseCopy;
		const regionCustomisations = appData?.pages?.[pageId]?.data?.customiseRegion;
		const previewPanelData = appData?.pages[this.props.id].data || {};
		const previewPanelHomeEntData = this.props.store?.['previewPanelHomeEnt-' + view.source] || {};
		const customRegionData = regionCustomisations?.[previewPanelHomeEntData.currentRegion];
		let { merchants = [], currentRegion, format, userSelectedAvailabilities, regionData, data } = previewPanelHomeEntData;
		merchants = merchants.slice(0, maxMerchants);
		const showDummy = (isMobile && (merchants.length % 2 !== 0)) || (!isMobile && merchants.length % 2 !== 0 && merchants.length >= 5);
		const title = copy[previewPanelData?.title] || previewPanelData?.title || customRegionData?.title || view.copy;

		return (
			<div class={s.merchantContainer}>
				{title && (
					<div class={joinClasses(s.title, 'xlargeB')}>
						{title}
					</div>
				)}
				<div class={joinClasses(
					s.merchants,
					merchants.length > 4 && s.over4Merchants,
					merchants.length > 6 && s.over6Merchants
				)}>
					{loading && this.renderSpinner()}
					{!loading && merchants.map((merchant, index) => {
						const logo = this.getLogoSrc(merchant, data[format][merchant].logo, currentRegion);
						const singleLinkOutData = this.getSingleLinkForMerchant(data[format][merchant], userSelectedAvailabilities);
						const logoAltText = this.getLogoAltText(merchant);

						return (
							<div
								class={s.merchant}
								onClick={e => {
									this.openMerchant(data[format][merchant], logo, singleLinkOutData, regionData, merchant, currentRegion, index, e);
								}}
								key={currentRegion + '-' + format + '-' + merchant}
							>
								<img src={logo} alt={logoAltText} />
							</div>
						);
					})}
					{showDummy && <div class={joinClasses(s.merchant, s.dummy)} />}
				</div>
			</div>
		);
	}

	renderShowtimesData(view) {
		if (!Theater || !ShowtimesMessage) {
			return;
		}

		const pageId = view.name;

		const { validCountry, boundingRegions } = this.state;
		const showtimesData = this.props.store?.showtimes?.data || [];
		const error = this.props.store?.showtimes?.error;
		const theaters = showtimesData.slice(0, 2);
		const additionalShowtimes = showtimesData.length - 1;

		const showtimesAppData = this.props.store?.appData?.pages?.[pageId]?.data || {};
		const copy = this.props.store?.appData.copy;
		const clientGeo = this.props.store?.client.geo;
		const sharedImageRoot = this.props.store?.appData?.urls?.roots?.sharedImages;
		let additionalText = copy.baseCopy?.$ADDITIONAL_SHOWTIMES || '<showtimes> additional showtimes at this theater';
		additionalText = additionalText.replace('<showtimes>', additionalShowtimes);
		const loading = this.props.store?.showtimes?.loading !== false;
		const deviceSize = this.props.store?.client?.deviceSize;

		const date = this.props.store?.showtimes?.filters?.selected?.date;
		const city = clientGeo.city;
		const title = [city, date && formatDateTime(date, 'ddd dd MMM')].filter(e => e).join(' • ');

		const pageData = this.props.appData.pages[this.props.id].data || {};
		const extraButtonBottom = pageData.extraButton?.position === 'bottom';
		const { activeOn } = pageData.extraButton || {};
		const extraBtnActive = activeOn && activeOn.split(',').map(e => e.trim()).includes(view.source);
		const showExtraButton = pageData.extraButton && extraButtonBottom && (!activeOn || extraBtnActive);

		let errorMessage;

		if (error) {
			errorMessage = (
				<ShowtimesMessage
					deviceSize={deviceSize}
					isMap={false}
					message={copy.baseCopy.$ERROR_SHOWTIMES}
					cta={copy.baseCopy.$ERROR_SHOWTIMES_CTA}
					buttonCopy={copy.baseCopy.$REFRESH || 'Refresh'}
					buttonTrigger={() => Store.emit('SHOWTIMES_REFRESH')}
					key="message-error"
					icon="calendar-empty"
					isPreviewPanel
				/>
			);
		}

		if (!validCountry && !loading) {
			const userCity = this.props.store.client.geo.city;
			let regionData = this.props.store.appData.meta.region;
			let appRegion = regionData.countryName;
			let uppercaseSlug = (regionData.slug || '').toUpperCase();
			if (boundingRegions && (boundingRegions.length > 1 || boundingRegions[0] !== uppercaseSlug)) {
				let sortedRegions = [uppercaseSlug].concat(boundingRegions.filter(r => r !== uppercaseSlug));
				appRegion = sortedRegions.join(', ');
			}

			let cta = copy.baseCopy.$ERROR_SHOWTIMES_LOCATION_CTA || 'Change your search location for new results';
			let message = copy.baseCopy.$ERROR_SHOWTIMES_LOCATION || 'It looks like you’re in %USER_CITY%, and this page is for users in %APP_REGION%';

			errorMessage = (
				<ShowtimesMessage
					deviceSize={deviceSize}
					isMap={false}
					icon="calendar-empty"
					cta={cta}
					message={message.replace('%USER_CITY%', userCity).replace('%APP_REGION%', appRegion)}
					key="message-bounding-region"
					isPreviewPanel
				/>
			);
		}


		return (
			<div
				ref={ref => this.$sections[pageId] = ref}
				class={joinClasses(s.view, s.showtimes, this.state.activeView === view && s.show)}
			>
				<div class={joinClasses(s.title, 'xlargeB')}>
					{title}
				</div>
				<div class={s.theaters}>
					{loading && this.renderSpinner()}
					{(!loading && errorMessage) && errorMessage}
					{(!loading && !errorMessage) && theaters.map((theater, i) => (
						<Theater
							ref={ref => this.$theaters[`theater${i}`] = ref}
							class={s.theater}
							theater={theater}
							mode="film"
							clientGeo={clientGeo}
							geoFromIP={this.state.geoFromIP || {}}
							onExpandClick={() => this.expandTheater(theater)}
							sharedImageRoot={sharedImageRoot}
							logoShade={this.logoShade}
							copy={copy}
							showtimesAppData={showtimesAppData}
							key={'theater-' + theater.id + i}
							trackConversion={this.trackConversion}
							additionalText={additionalShowtimes >= 1 && additionalText}
							additionalTextOnClick={() => Store.emit('SHOWTIMES_SHOW', null, null, pageId)}
						/>
					))}
				</div>
				<Button
					class={s.button}
					type="floating"
					trigger={() => {
						Store.emit('PREVIEW_PANEL_MORE_SHOWTIMES_CLICK');
						Store.emit('SHOWTIMES_SHOW');
					}}
				>
					{copy?.baseCopy.$MORE_SHOWTIMES || 'More Showtimes'}
				</Button>
				{showExtraButton && this.renderExtraButton(pageData.extraButton, extraButtonBottom)}
			</div>
		);
	}

	getLogoAltText(merchant, merchantData) {
		const merchantDetailsOverrides = this.props.store?.appData.pages.boltHomeEnt?.data.overrideMerchantDetails || {};
		const merchantName = merchantDetailsOverrides[merchant]?.name || merchant;
		let logoAltText = merchantDetailsOverrides[merchant]?.logoAltText || accessNested(this.props, 'store.appData.copy.baseCopy.$MERCHANT_LOGO_ALT_TEXT', '');
		logoAltText = logoAltText.replace('<merchant>', merchantName);
		return logoAltText;
	}

	closeMerchantSection() {
		Store.emit('CLOSE_MERCHANT_SECTION');
		this.setState({
			merchantScreenOpen: false
		});
	}

	maybeCloseMerchantSection(e) {
		if (e.target === this.merchantPanel?.$merchantSectionContainer || e.target === this.merchantPanel?.$merchantSectionScroller) {
			this.closeMerchantSection();
		}
	}

	getDataProviderFromId(productId) {
		if (!productId) return 'Manual';
		if (productId.startsWith('FAF')) return 'FindAnyFilm';
		if (productId.startsWith('JW')) return 'JustWatch';
	}

	onPriceBtnClick(product, availability, merchant, region) {
		const { selectedMerchant, regionToTrack, selectedFormat } = this.state;
		const dataProvider = this.getDataProviderFromId(product.id);

		Store.emit('HOME_ENT_CONVERSION', {
			merchant: merchant || selectedMerchant,
			selectedFormat,
			availability,
			product,
			dataProvider,
			region: region || regionToTrack
		}, 'previewpanel');
	}

	scrollToNext() {
		let scrollContainer = document.getElementById('mainScroll');
		let scrollTo = document.querySelector('.' + s.wrapper).nextElementSibling;
		const isDesktop = this.props.store?.client?.isDesktopSize || false;
		const hasSonyHeader = this.props.appData?.options.sonyFeatures?.sonyHeader || false;
		const scrollOffset = isDesktop ? (hasSonyHeader ? 34 : 0) : (hasSonyHeader ? 58 : getHeaderHeight());
		smoothScrollTo(scrollContainer, scrollTo, 300, { offset: scrollOffset });
	}

	renderMerchantPanel(pageId) {
		if (!MerchantPanel) {
			return;
		}

		const { selectedMerchant, selectedMerchantData, selectedLogo, merchantScreenOpen } = this.state;
		const previewPanelHomeEntData = this.props.store?.['previewPanelHomeEnt-' + pageId] || {};
		let { userSelectedAvailabilities, regionData } = previewPanelHomeEntData;

		const fallbackFormat = this.getFallbackFormat('tt');
		const logoAltText = this.getLogoAltText(selectedMerchant, selectedMerchantData);

		return (
			<MerchantPanel
				ref={ref => this.merchantPanel = ref}
				appData={this.props.store?.appData}
				userSelectedAvailabilities={userSelectedAvailabilities}
				availabilityOrder={this.availabilityOrder}
				merchantScreenOpen={merchantScreenOpen}
				maybeCloseMerchantSection={this.maybeCloseMerchantSection}
				closeMerchantSection={this.closeMerchantSection}
				onPriceBtnClick={this.onPriceBtnClick}
				selectedLogo={selectedLogo}
				selectedMerchantData={selectedMerchantData}
				selectedMerchant={selectedMerchant}
				fallbackFormat={fallbackFormat}
				selectedRegionData={regionData}
				logoAltText={logoAltText}
				isPreviewPanel
			/>
		);
	}

	renderSpinner() {
		return (
			<div class={s.spinner} />
		);
	}

	renderScrollArrow(isMobile, stickyFooter) {
		const externalBannerOpen = this.props.store?.externalCookieBanner?.bannerOpen;
		const copy = this.props.appData?.copy || {};
		const interstitialOpen = this.state.merchantScreenOpen;

		return (
			<Button
				class={joinClasses(s.arrowBtn, stickyFooter && s.stickyFooter, (isMobile && (externalBannerOpen || interstitialOpen)) && s.hide)}
				trigger={this.scrollToNext}
				key="arrow"
				ariaLabel={copy.accessibilityCopy.$SCROLL_ARROW_ARIA}
			>
				<ArrowDown class={s.arrowDown} aria-hidden />
			</Button>
		);
	}

	renderSocials(stickyFooter, appData) {
		return (
			<Socials
				class={joinClasses(s.socials, stickyFooter && s.socialsStickyFooter)}
				socials={appData?.header.powsterHeader.follow}
				key="socials"
			/>
		);
	}

	renderProviderInterstitial() {
		const shouldShowProviderInterstitial = this.props.store?.previewPanel?.providerInterstitialOpen;

		if (!shouldShowProviderInterstitial || !ProviderInterstitial) {
			return;
		}

		const selectedTheater = this.props.store?.previewPanel?.selectedTheater || {};
		const selectedScreening = this.props.store?.previewPanel?.selectedScreening || {};
		const sharedImageRoot = this.props.store?.appData?.urls.roots.sharedImages || '';
		const isDesktopSize = this.props.store?.client.isDesktopSize || false;
		const copy = this.props.store?.appData.copy || {};

		return (
			<ProviderInterstitial
				selectedTheater={selectedTheater}
				selectedScreening={selectedScreening}
				sharedImageRoot={sharedImageRoot}
				logoShade={this.logoShade}
				isDesktopSize={isDesktopSize}
				copy={copy}
				trackConversion={this.trackConversion}
				key="provider-interstitial"
				isPreviewPanel
			/>
		);
	}

	renderView(view) {
		if (this.isShowtimesView(view)) {
			return this.renderShowtimesData(view);
		}
		if (this.isHomeEntView(view)) {
			return this.renderHomeEntData(view);
		}
	}

	render(props, state) {
		const { id, appData, store } = props;
		const { scrolledALittleBit } = state;
		const pageData = appData.pages[id].data || {};
		const isSection = appData.pages[id].section;
		const tt = pageData?.tt;

		const previewPanelReplacingHomePage = appData?.pages.boltPreviewPanel && !appData?.pages.boltHome;
		const isMobile = !store?.client.isDesktopSize;
		const stickyFooter = (appData?.footer.defaultFooter.position || 'fixed') === 'fixed';
		const socialIconsMobile = pageData.socialIconsMobile;
		const showSocials = (isMobile && socialIconsMobile) || (!isMobile && !stickyFooter);
		const extraButtonBottom = pageData.extraButton?.position === 'bottom';

		return (
			<div
				ref={ref => this.wrapper = ref}
				class={joinClasses(
					s.wrapper,
					isSection && s.section,
					previewPanelReplacingHomePage && s.replacesHomePage,
					scrolledALittleBit && s.scrolledALittleBit
				)}
				data-section={id}
				data-section-id={id}
			>
				{this.renderBgContent()}
				<div class={s.container} onTouchStart={() => Store.emit('PLAY_BACKGROUND_VIDEO')}>
					{tt && this.renderTT(tt)}
					{(pageData.extraButton && !extraButtonBottom) && this.renderExtraButton(pageData.extraButton)}
					{!this.displayMerchantViewsStacked && this.renderToggle()}
					<div ref={ref => this.sectionContainer = ref} class={s.data} key="views">
						{this.views.map(this.renderView)}
					</div>
				</div>
				{this.homeEntEnabled && this.renderMerchantPanel()}
				{this.showtimesEnabled && this.renderProviderInterstitial()}
				{previewPanelReplacingHomePage && this.renderScrollArrow(isMobile, stickyFooter)}
				{showSocials && this.renderSocials(stickyFooter, appData)}
				{this.renderOverlayedContent()}
			</div>
		);
	}
}